import axios from 'axios'

// axios 配置
axios.defaults.timeout = 60 * 1000
axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT
axios.defaults.withCredentials = true

// http request 拦截器
axios.interceptors.request.use(
  function(config) {
    if (
      process.env &&
      process.env.VUE_APP_SITE_ID &&
      !(config.headers && config.headers['X-SITE-ID'])
    ) {
      config.headers['X-SITE-ID'] = process.env.VUE_APP_SITE_ID
    }
    return config
  },
  function(err) {
    return Promise.reject(err)
  }
)

// 获取全景图数据
const getPanoramas = () =>
  axios({
    url: '/business/panorama/',
    method: 'GET'
  })

export { getPanoramas }
